<template>
  <ul class="wc-item-group-menu nav">
    <template v-if="circularMenu && circularMenu.length">
      <WCItemGroupDropdown
        :group="circularMenuItems"
        @selected="select"
        :showViewAll="false"
        :wcHeaderHeight="wcHeaderHeight"
      />
    </template>
    <template v-if="menu && menu.children">
      <template v-for="group in menu.children">
        <li v-if="!group.children || !group.children.length" class="nav-item" :key="group.id">
          <a
            class="nav-link h4 text-primary-contrast mb-0"
            href="#"
            @click.prevent="select(group.id)"
          >
            {{ group.name }}
          </a>
        </li>
        <WCItemGroupDropdown
          v-else
          :key="group.id"
          :group="group"
          @selected="select"
          :wcHeaderHeight="wcHeaderHeight"
        />
      </template>
    </template>
  </ul>
</template>

<script>
import WCItemGroupDropdown from './WCItemGroupDropdown.vue';
import ItemGroupMixin from '../../modules/filters/mixins/ItemGroupMixin';

export default {
  name: 'WCItemGroupMenu',
  components: { WCItemGroupDropdown },
  mixins: [ItemGroupMixin],
  props: {
    menu: {
      type: Object,
    },
    circularMenu: {
      type: Array,
    },
    wcHeaderHeight: {
      required: false,
      type: String,
      default: '0px',
    },
  },
  computed: {
    /**
     * Construct circular menu items object
     */
    circularMenuItems() {
      return {
        name: this.$t('currentSpecials'),
        children: this.circularMenu,
      };
    },
  },
};
</script>

<style scoped lang="scss">
ul li:first-child > ::v-deep a {
  padding-left: 0;
}
</style>
